<div
  class="facturer-multi-backdrop annuler-multi-backdrop"
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="facturer-multi-title"
>
  <div class="facturer-multi-panel annuler-multi-panel modal-panel" (click)="onPanelClick($event)">
    <div class="modal-header modal_head_title">
      <h3 id="facturer-multi-title">{{ modalTitle }}</h3>
      <button type="button" class="close-btn" (click)="onClose()" [disabled]="submitting">×</button>
    </div>

    <div class="modal-content annuler-multi-body">
      <!-- Étape 1 : liste des documents -->
      <ng-container *ngIf="step === 1">
        <img
          class="facturer-preview-img"
          src="assets/images/logo/CardTicketCaisse.png"
          alt="Cycle de vie d’un document — Ticket vers Facture"
        />
        <p class="text-muted mb-3" [innerHTML]="introHtml"></p>
        <p *ngIf="excludedCount > 0 && canProceed" class="text-warning small mb-2">
          {{ excludedCount }} ticket(s) non retenu(s) (entrepôt / client différent, déjà facturé, etc.).
        </p>

        <app-detaille-multi-selection-ticket
          [ticketIds]="ticketIds"
          [allowConsolideTickets]="allowConsolideTickets"
          selectionMode="facture"
          (rowsChange)="onRowsChange($event)"
          (canProceedChange)="onCanProceedChange($event)"
          (blockReasonChange)="onBlockReasonChange($event)"
          (excludedCountChange)="onExcludedCountChange($event)"
        ></app-detaille-multi-selection-ticket>

        <p *ngIf="blockReason && !canProceed" class="text-danger small mb-0 mt-2">{{ blockReason }}</p>
      </ng-container>

      <!-- Étape 2 : choix du contenu de la facture -->
      <ng-container *ngIf="step === 2">
        <p class="text-muted mb-3">
          Choisissez le contenu de la facture générée à partir des
          {{ rows.length }} ticket(s) sélectionné(s).
        </p>

        <div class="facture-choice-cards">
          <div
            class="option-card bordered"
            [class.selected]="factureMode === 'financial'"
            [class.disabled]="submitting"
            (click)="!submitting && selectFactureMode('financial')"
          >
            <div class="card-content">
              <div class="icon-title-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                     stroke-linejoin="round">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
                <span class="option-title">Produits financiers</span>
                <p>Une seule ligne financière (Recette, etc.) consolidant le total des tickets.</p>
              </div>
              <label class="container">
                <input
                  type="radio"
                  name="factureMode"
                  value="financial"
                  [checked]="factureMode === 'financial'"
                  (change)="selectFactureMode('financial')"
                  [disabled]="submitting"
                  class="form-check-input"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div
            class="option-card bordered"
            [class.selected]="factureMode === 'product_lines'"
            [class.disabled]="submitting"
            (click)="!submitting && selectFactureMode('product_lines')"
          >
            <div class="card-content">
              <div class="icon-title-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                     stroke-linejoin="round">
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
                <span class="option-title">Ligne des produits</span>
                <p>La facture reprend le détail des produits vendus dans les tickets sélectionnés.</p>
              </div>
              <label class="container">
                <input
                  type="radio"
                  name="factureMode"
                  value="product_lines"
                  [checked]="factureMode === 'product_lines'"
                  (change)="selectFactureMode('product_lines')"
                  [disabled]="submitting"
                  class="form-check-input"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Étape 3 : choix du produit financier -->
      <ng-container *ngIf="step === 3">
        <p class="text-muted mb-3">Choisissez le produit financier à utiliser pour la facture.</p>

        <div class="facture-choice-list" *ngIf="financialProducts.length; else noFinancial">
          <label
            class="facture-choice-card"
            *ngFor="let p of financialProducts"
            [class.selected]="selectedFinancialProductId === p.id"
          >
            <input
              type="radio"
              name="financialProduct"
              [value]="p.id"
              [checked]="selectedFinancialProductId === p.id"
              (change)="selectFinancialProduct(p.id)"
              [disabled]="submitting"
            />
            <span class="facture-choice-body">
              <span class="facture-choice-title">{{ productLabel(p) }}</span>
            </span>
          </label>
        </div>
        <ng-template #noFinancial>
          <p class="text-warning small mb-0">
            Aucun produit financier disponible. Le produit « Recette » sera créé automatiquement.
          </p>
        </ng-template>
      </ng-container>
    </div>

    <div class="annuler-multi-footer">
      <!-- Étape 1 -->
      <ng-container *ngIf="step === 1">
        <button type="button" class="btn btn-outline-secondary" (click)="onClose()" [disabled]="submitting">
          Fermer
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSuivant()"
          [disabled]="!canProceed || submitting || rows.length === 0"
        >
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Suivant
        </button>
      </ng-container>

      <!-- Étape 2 -->
      <ng-container *ngIf="step === 2">
        <button type="button" class="btn btn-outline-secondary" (click)="backToList()" [disabled]="submitting">
          Précédent
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSuivantFromChoice()"
          [disabled]="submitting || rows.length === 0"
        >
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
          {{ factureMode === 'product_lines' ? 'Générer' : 'Suivant' }}
        </button>
      </ng-container>

      <!-- Étape 3 -->
      <ng-container *ngIf="step === 3">
        <button type="button" class="btn btn-outline-secondary" (click)="backToChoice()" [disabled]="submitting">
          Précédent
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="confirmFinancial()"
          [disabled]="submitting || rows.length === 0"
        >
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Générer
        </button>
      </ng-container>
    </div>
  </div>
</div>
